import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function getAccounts(params) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/list`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function getParentAccounts(params) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parents`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}
export async function getSalesAccountsDropdownList(params) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/dropdown`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function getParentAccountsDropdownList(params) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parents-dropdown`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function getParentAccount(id) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parents/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function createParentAccount(data) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parents`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((err) => err?.response?.data);
}

export async function UpdateParentAccount(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parent/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data);
}

export async function deleteParentAccount(id) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/parents/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response.data);
}

export async function getAccountType() {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/types`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function createAccount(data) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((err) => err?.response?.data);
}

export async function UpdateAccount(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data);
}

export async function getAccount(id) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/details/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}
export async function deleteAccount(id) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response.data);
}

export async function changeAccountStatus(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/accounting/accounts/${id}/status`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.patch(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
